import { defineMessage } from 'services/localization';

export const messages = {
    header: defineMessage('review_step'),
    removeStepTitle: defineMessage('remove_review_step'),
    note: defineMessage('reviewers_will_need_to___for_further_processing'),
    reviewers: defineMessage('reviewers'),
    footerText: defineMessage('add_reviewers_who_will__proval_decision_is_made'),
    addReviewer: defineMessage('add_a_reviewer_1'),
    reviewerMatrixDescription: defineMessage('define_review_condition_rs_in_the_review_matrix'),
    defaultReviewer: defineMessage('default_reviewer_1'),
    defaultReviewerDescription: defineMessage('a_default_reviewer_is_a_viewer_specified_for_it'),
};
